/* DUSKY'S SHRINE WISHLIST — resilient product-card and PDP control */
(function(){
  'use strict';
  var STORAGE_KEY='wishlist';
  var MAX_WISHLIST_ITEMS=1000;

  function cleanWishlist(handles){
    return Array.from(new Set((Array.isArray(handles)?handles:[]).filter(Boolean))).slice(0,MAX_WISHLIST_ITEMS);
  }
  function showWishlistLimit(){
    var previous=document.getElementById('ds-wishlist-limit');
    if(previous)previous.remove();
    var toast=document.createElement('div');
    toast.id='ds-wishlist-limit';
    toast.className='wl-limit-toast';
    toast.setAttribute('role','status');
    toast.setAttribute('aria-live','polite');
    toast.textContent='Your wishlist can hold up to 1,000 products.';
    document.body.appendChild(toast);
    requestAnimationFrame(function(){toast.classList.add('is-visible');});
    clearTimeout(showWishlistLimit.timer);
    showWishlistLimit.timer=setTimeout(function(){
      toast.classList.remove('is-visible');
      setTimeout(function(){if(toast.parentNode)toast.remove();},250);
    },3500);
  }
  document.addEventListener('wishlist:limit',showWishlistLimit);

  class WishlistButton extends HTMLElement {
    connectedCallback(){
      if(this.dataset.wishlistReady==='true')return;
      this.dataset.wishlistReady='true';
      this.handle=(this.dataset.productHandle||'').trim();
      if(!this.handle)return;
      this.setAttribute('role','button');
      if(!this.hasAttribute('tabindex'))this.tabIndex=0;
      this._click=this.onClick.bind(this);
      this._keydown=this.onKeydown.bind(this);
      this._change=this.onWishlistChange.bind(this);
      this.addEventListener('click',this._click);
      this.addEventListener('keydown',this._keydown);
      document.addEventListener('wishlist:change',this._change);
      this.render();
    }
    disconnectedCallback(){
      if(this._click)this.removeEventListener('click',this._click);
      if(this._keydown)this.removeEventListener('keydown',this._keydown);
      if(this._change)document.removeEventListener('wishlist:change',this._change);
      delete this.dataset.wishlistReady;
    }
    onClick(event){
      event.preventDefault();
      event.stopPropagation();
      var wishlist=WishlistButton.getWishlist();
      var index=wishlist.indexOf(this.handle);
      if(index===-1){
        if(wishlist.length>=MAX_WISHLIST_ITEMS){
          document.dispatchEvent(new CustomEvent('wishlist:limit',{detail:{max:MAX_WISHLIST_ITEMS}}));
          return;
        }
        wishlist.push(this.handle);
      }else{
        wishlist.splice(index,1);
      }
      WishlistButton.setWishlist(wishlist);
      this.render();
      document.dispatchEvent(new CustomEvent('wishlist:change',{detail:{handle:this.handle,handles:wishlist.slice()}}));
    }
    onKeydown(event){
      if(event.key==='Enter'||event.key===' '){
        event.preventDefault();
        this.onClick(event);
      }
    }
    onWishlistChange(event){
      if(!event.detail||!event.detail.handle||event.detail.handle===this.handle)this.render();
    }
    render(){
      var isActive=WishlistButton.getWishlist().includes(this.handle);
      this.classList.toggle('is-active',isActive);
      this.setAttribute('aria-pressed',String(isActive));
      this.setAttribute('aria-label',isActive?(this.dataset.labelRemove||'Remove from wishlist'):(this.dataset.labelAdd||'Add to wishlist'));
    }
    static getWishlist(){
      try{
        var parsed=JSON.parse(localStorage.getItem(STORAGE_KEY)||'[]');
        if(Array.isArray(parsed)){WishlistButton.memory=cleanWishlist(parsed);return WishlistButton.memory.slice();}
      }catch(error){}
      return cleanWishlist(WishlistButton.memory);
    }
    static setWishlist(handles){
      WishlistButton.memory=cleanWishlist(handles);
      try{localStorage.setItem(STORAGE_KEY,JSON.stringify(WishlistButton.memory));}catch(error){}
    }
  }
  WishlistButton.memory=[];
  if(!customElements.get('wishlist-button'))customElements.define('wishlist-button',WishlistButton);
})();

/* ---- Predictive search injected into collection grids without one ---- */
(function(){
  function initGridSearch(){
    document.querySelectorAll('[class*="ai-curated-collections__grid-"]').forEach(function(grid){
      if(grid.dataset.gridSearchReady) return; grid.dataset.gridSearchReady='1';
      var section = grid.closest('[class*="ai-curated-collections-"]') || grid.parentElement;
      if(section && section.querySelector('input[class*="ai-curated-collections__search-"]')) return;
      var cards = Array.prototype.slice.call(grid.querySelectorAll('a[class*="ai-curated-collections__card-"]'));
      if(cards.length < 2) return;
      var wrap=document.createElement('div'); wrap.className='acc-gridsearch-wrap';
      var input=document.createElement('input'); input.type='search'; input.className='acc-gridsearch'; input.setAttribute('placeholder','Search...'); input.setAttribute('autocomplete','off');
      var box=document.createElement('div'); box.className='acc-gridsearch-suggest';
      wrap.appendChild(input); wrap.appendChild(box);
      grid.parentNode.insertBefore(wrap, grid);
      var items = cards.map(function(c){ var te=c.querySelector('[class*="__title-"]'); var t=(te?te.textContent:'').trim(); return {card:c, title:t, lc:t.toLowerCase(), href:c.getAttribute('href')}; });
      input.addEventListener('input', function(){
        var q=input.value.trim().toLowerCase();
        items.forEach(function(it){ it.card.style.display=(q===''||it.lc.indexOf(q)!==-1)?'':'none'; });
        if(q===''){ box.innerHTML=''; box.classList.remove('open'); return; }
        var m=items.filter(function(it){return it.lc.indexOf(q)!==-1;}).slice(0,8);
        box.innerHTML=m.map(function(x){return '<a href="'+x.href+'">'+x.title.replace(/</g,'&lt;')+'</a>';}).join('');
        box.classList.toggle('open', m.length>0);
      });
      input.addEventListener('keydown', function(e){ if(e.key==='Enter'){ var a=box.querySelector('a'); if(a) window.location.href=a.getAttribute('href'); } });
      document.addEventListener('click', function(e){ if(!wrap.contains(e.target)) box.classList.remove('open'); });
    });
  }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded', initGridSearch); } else { initGridSearch(); }
})();

/* ---- Header heart icon (wishlist) to the left of the cart ---- */
(function(){
  function wlCount(){ try{ return Array.from(new Set((JSON.parse(localStorage.getItem('wishlist'))||[]).filter(Boolean))).slice(0,1000).length; }catch(e){ return 0; } }
  function initHeart(){
    var cart=document.querySelector('.header__icons a.header__icon[href$="/cart"], .header__icons a.header__icon[href*="/cart"]');
    if(!cart) return;
    var container=cart.parentElement;
    if(container.querySelector('.header__icon--wishlist')) return;
    var a=document.createElement('a');
    a.href='/pages/wishlist';
    a.className='header__icon relative header__icon--wishlist';
    a.setAttribute('aria-label','Wishlist');
    a.innerHTML='<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.6l-1-1a5.5 5.5 0 1 0-7.8 7.8l1 1L12 21l7.8-7.6 1-1a5.5 5.5 0 0 0 0-7.8z"/></svg><span class="wl-count" hidden></span>';
    container.insertBefore(a, cart);
    function upd(){ var n=wlCount(); var s=a.querySelector('.wl-count'); if(n>0){ s.textContent=n; s.hidden=false; } else { s.hidden=true; } }
    upd(); document.addEventListener('wishlist:change', upd);
  }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded', initHeart); } else { initHeart(); }
  document.addEventListener('shopify:section:load', initHeart);
})();

/* ---- Wishlist page renderer: two columns, 1,000 items, lazy product loading ---- */
(function(){
  var MAX_WISHLIST_ITEMS=1000;
  var MAX_CONCURRENT_REQUESTS=6;

  function money(cents){
    try{return (Number(cents)/100).toLocaleString('en-IN',{style:'currency',currency:'INR',maximumFractionDigits:0});}
    catch(e){return '₹'+Math.round(Number(cents)/100);}
  }
  function escapeHtml(value){
    return String(value==null?'':value).replace(/[&<>"']/g,function(ch){
      return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[ch];
    });
  }
  function clean(handles){
    return Array.from(new Set((Array.isArray(handles)?handles:[]).filter(Boolean))).slice(0,MAX_WISHLIST_ITEMS);
  }
  function savedHandles(){
    try{return clean(JSON.parse(localStorage.getItem('wishlist')||'[]'));}
    catch(e){return [];}
  }
  function saveHandles(handles){
    var next=clean(handles);
    try{localStorage.setItem('wishlist',JSON.stringify(next));}catch(e){}
    return next;
  }
  function shopRoot(){
    var root=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
    return root.charAt(root.length-1)==='/'?root:root+'/';
  }
  function availableVariant(product){
    var variants=Array.isArray(product.variants)?product.variants:[];
    for(var i=0;i<variants.length;i++){
      if(variants[i]&&variants[i].available!==false)return variants[i];
    }
    return null;
  }
  function showEmpty(root){
    root.innerHTML='<p style="text-align:center;opacity:.65;padding:48px 16px;">Your wishlist is empty. Tap the heart on any product to save it here.</p>';
  }
  function removeSavedHandle(handle,card,grid,root){
    saveHandles(savedHandles().filter(function(item){return item!==handle;}));
    if(card&&card.parentNode)card.remove();
    document.dispatchEvent(new CustomEvent('wishlist:change',{detail:{handle:handle,handles:savedHandles()}}));
    if(!grid.querySelector('.wl-card'))showEmpty(root);
  }
  function hydrateCard(card,product,grid,root){
    var variant=availableVariant(product);
    var image=product.featured_image||(product.images&&product.images[0])||'';
    var handle=String(product.handle||card.dataset.handle||'');
    var productUrl=shopRoot()+'products/'+encodeURIComponent(handle);
    var price=variant&&variant.price!=null?variant.price:product.price;
    card.className='wl-card';
    card.removeAttribute('aria-busy');
    card.innerHTML=
      '<button type="button" class="wl-remove" aria-label="Remove '+escapeHtml(product.title)+' from wishlist" title="Remove from wishlist">&times;</button>'+
      '<a class="wl-cardlink" href="'+escapeHtml(productUrl)+'">'+
        '<span class="wl-img">'+(image?'<img loading="lazy" src="'+escapeHtml(image)+'" alt="'+escapeHtml(product.title)+'">':'')+'</span>'+
        '<span class="wl-cardmeta"><span class="wl-title">'+escapeHtml(product.title)+'</span><span class="wl-price">'+money(price)+'</span></span>'+
      '</a>'+
      '<div class="wl-actions">'+
        '<button type="button" class="wl-action wl-add"'+(variant?'':' disabled aria-disabled="true"')+'>Add to cart</button>'+
        '<button type="button" class="wl-action wl-buy"'+(variant?'':' disabled aria-disabled="true"')+'>Buy now</button>'+
      '</div>';

    card.querySelector('.wl-remove').addEventListener('click',function(){
      removeSavedHandle(handle,card,grid,root);
    });
    if(!variant)return;

    var add=card.querySelector('.wl-add');
    var buy=card.querySelector('.wl-buy');
    add.addEventListener('click',function(){
      if(add.disabled)return;
      var original=add.textContent;
      add.disabled=true;
      add.textContent='Adding…';
      fetch(shopRoot()+'cart/add.js',{
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({items:[{id:variant.id,quantity:1}]})
      }).then(function(response){
        if(!response.ok)throw new Error('Cart add failed');
        return response.json();
      }).then(function(cartItem){
        add.textContent='Added ✓';
        document.dispatchEvent(new CustomEvent('cart:refresh',{detail:{source:'wishlist',item:cartItem}}));
        document.dispatchEvent(new CustomEvent('cart:change',{detail:{source:'wishlist',item:cartItem}}));
        setTimeout(function(){add.disabled=false;add.textContent=original;},1700);
      }).catch(function(){
        add.textContent='Try again';
        setTimeout(function(){add.disabled=false;add.textContent=original;},1700);
      });
    });
    buy.addEventListener('click',function(){
      window.location.assign(shopRoot()+'cart/'+encodeURIComponent(String(variant.id))+':1?checkout');
    });
  }
  function renderWishlist(){
    var root=document.getElementById('wishlist-root');
    if(!root)return;
    var handles=savedHandles();
    saveHandles(handles);
    if(!handles.length){showEmpty(root);return;}

    root.innerHTML='<div class="wl-grid" aria-label="Saved products"></div>';
    var grid=root.querySelector('.wl-grid');
    var fragment=document.createDocumentFragment();
    handles.forEach(function(handle){
      var card=document.createElement('article');
      card.className='wl-card wl-card--loading';
      card.dataset.handle=handle;
      card.setAttribute('aria-busy','true');
      card.innerHTML='<div class="wl-skeleton" aria-hidden="true"></div>';
      fragment.appendChild(card);
    });
    grid.appendChild(fragment);

    var queue=[];
    var active=0;
    function drain(){
      while(active<MAX_CONCURRENT_REQUESTS&&queue.length){
        var card=queue.shift();
        if(!card||!card.isConnected)continue;
        active++;
        var handle=card.dataset.handle;
        fetch(shopRoot()+'products/'+encodeURIComponent(handle)+'.js',{headers:{'Accept':'application/json'}})
          .then(function(response){
            if(response.status===404)return null;
            if(!response.ok)throw new Error('Product request failed');
            return response.json();
          })
          .then(function(product){
            if(!product){removeSavedHandle(handle,card,grid,root);return;}
            hydrateCard(card,product,grid,root);
          })
          .catch(function(){
            card.className='wl-card';
            card.removeAttribute('aria-busy');
            card.innerHTML='<div class="wl-load-error">This product could not be loaded. Refresh to try again.</div>';
          })
          .then(function(){active--;drain();},function(){active--;drain();});
      }
    }
    function enqueue(card){
      if(card.dataset.queued==='true')return;
      card.dataset.queued='true';
      queue.push(card);
      drain();
    }

    var cards=Array.prototype.slice.call(grid.querySelectorAll('.wl-card'));
    if('IntersectionObserver' in window){
      var observer=new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          if(!entry.isIntersecting)return;
          observer.unobserve(entry.target);
          enqueue(entry.target);
        });
      },{rootMargin:'900px 0px'});
      cards.forEach(function(card){observer.observe(card);});
    }else{
      cards.forEach(enqueue);
    }
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',renderWishlist);}
  else{renderWishlist();}
})();

/* ---- Custom social share row: X, Instagram, Facebook, LinkedIn, Pinterest, WhatsApp ---- */
(function(){
  var WA='919346163977';
  var IG='https://www.instagram.com/duskysshrine/';
  var SVG={
    x:'<svg viewBox="0 0 24 24" width="20" height="20" fill="#000000" aria-hidden="true"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>',
    instagram:'<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="#E1306C" stroke-width="2" aria-hidden="true"><rect x="2" y="2" width="20" height="20" rx="5.5"/><circle cx="12" cy="12" r="4.3"/><circle cx="17.6" cy="6.4" r="1.3" fill="#E1306C" stroke="none"/></svg>',
    facebook:'<svg viewBox="0 0 24 24" width="22" height="22" fill="#1877F2" aria-hidden="true"><path d="M24 12a12 12 0 1 0-13.875 11.85v-8.385H7.078V12h3.047V9.356c0-3.007 1.792-4.669 4.533-4.669 1.313 0 2.686.235 2.686.235v2.953H15.83c-1.49 0-1.955.925-1.955 1.874V12h3.328l-.532 3.465h-2.796v8.385A12 12 0 0 0 24 12z"/></svg>',
    linkedin:'<svg viewBox="0 0 24 24" width="22" height="22" fill="#0A66C2" aria-hidden="true"><path d="M20.45 20.45h-3.55v-5.57c0-1.33-.02-3.04-1.85-3.04-1.85 0-2.14 1.45-2.14 2.94v5.66H9.35V9h3.41v1.56h.05c.47-.9 1.63-1.85 3.36-1.85 3.6 0 4.27 2.37 4.27 5.45v6.29zM5.34 7.43a2.06 2.06 0 1 1 0-4.12 2.06 2.06 0 0 1 0 4.12zM7.12 20.45H3.56V9h3.56v11.45zM22.22 0H1.77C.79 0 0 .77 0 1.72v20.56C0 23.23.79 24 1.77 24h20.45c.98 0 1.78-.77 1.78-1.72V1.72C24 .77 23.2 0 22.22 0z"/></svg>',
    pinterest:'<svg viewBox="0 0 24 24" width="22" height="22" fill="#E60023" aria-hidden="true"><path d="M12 0C5.37 0 0 5.37 0 12c0 5.08 3.16 9.42 7.62 11.17-.1-.95-.2-2.4.04-3.44.22-.93 1.4-5.96 1.4-5.96s-.36-.72-.36-1.78c0-1.66.97-2.9 2.17-2.9 1.02 0 1.51.77 1.51 1.69 0 1.03-.65 2.57-.99 4-.28 1.19.6 2.16 1.77 2.16 2.12 0 3.75-2.24 3.75-5.47 0-2.86-2.06-4.86-5-4.86-3.4 0-5.4 2.55-5.4 5.19 0 1.03.4 2.13.89 2.73.1.12.11.22.08.34l-.33 1.36c-.05.22-.17.27-.4.16-1.5-.7-2.43-2.88-2.43-4.64 0-3.78 2.75-7.25 7.92-7.25 4.16 0 7.39 2.96 7.39 6.92 0 4.13-2.6 7.45-6.22 7.45-1.21 0-2.35-.63-2.74-1.38l-.75 2.84c-.27 1.04-1 2.35-1.49 3.15C9.57 23.82 10.76 24 12 24c6.63 0 12-5.37 12-12S18.63 0 12 0z"/></svg>',
    whatsapp:'<svg viewBox="0 0 24 24" width="22" height="22" fill="#25D366" aria-hidden="true"><path d="M17.5 14.4c-.3-.15-1.77-.87-2.04-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.17-.17.2-.35.22-.65.07-.3-.15-1.26-.46-2.4-1.48-.89-.79-1.49-1.77-1.66-2.07-.17-.3-.02-.46.13-.61.13-.13.3-.35.44-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.67-1.61-.92-2.21-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.48 0 1.46 1.06 2.87 1.21 3.07.15.2 2.1 3.2 5.08 4.49.71.31 1.26.49 1.69.63.71.23 1.36.2 1.87.12.57-.09 1.77-.72 2.02-1.42.25-.7.25-1.29.17-1.42-.07-.13-.27-.2-.57-.35zM12.05 21.5a9.4 9.4 0 0 1-4.8-1.32l-.34-.2-3.57.94.95-3.48-.22-.36a9.42 9.42 0 1 1 8.32 4.42zM20.52 3.48A11.76 11.76 0 0 0 12.05 0C5.5 0 .2 5.3.2 11.82c0 2.08.55 4.11 1.6 5.9L.1 24l6.45-1.69a11.8 11.8 0 0 0 5.5 1.4h.01c6.55 0 11.86-5.3 11.86-11.82a11.74 11.74 0 0 0-3.4-8.41z"/></svg>'
  };
  function ensureStyle(){
    if(document.getElementById('ds-share-style')) return;
    var s=document.createElement('style'); s.id='ds-share-style';
    s.textContent='.social-share ul.social{gap:6px;align-items:center;}.social-share ul.social li{margin:0;}.social-share ul.social .social__link{padding:6px;border-radius:50%;transition:background .15s ease,transform .15s ease;}.social-share ul.social .social__link:hover{background:rgba(0,0,0,.06);transform:translateY(-1px);}.social-share ul.social .social__link svg{display:block;}';
    document.head.appendChild(s);
  }
  function popupify(a){
    a.addEventListener('click', function(e){
      var href=this.getAttribute('href'); if(!href) return;
      e.preventDefault();
      var w=620,h=540,y=Math.max(0,(screen.height-h)/2),x=Math.max(0,(screen.width-w)/2);
      var win=window.open(href,'ds-share','scrollbars=yes,resizable=yes,width='+w+',height='+h+',top='+y+',left='+x);
      if(!win){ window.open(href,'_blank'); }
    });
  }
  function ensureArticleShare(){
    var isArticle=document.body.classList.contains('template-article')||/\/blogs\/[^\/]+\/[^\/]+/.test(location.pathname);
    if(!isArticle) return null;
    var title=document.querySelector('.article__title, .article-template__title, .article-header__title, article h1, main h1, h1.h1, h1');
    if(!title) return null;
    var share=document.querySelector('.social-share');
    if(!share){
      share=document.createElement('div');
      share.className='social-share flex items-center ds-share-article';
      share.innerHTML='<p class="social-share__heading mb-0 font-bold">Share:</p><ul class="social inline-flex flex-wrap"></ul>';
    }
    if(title.nextElementSibling!==share){ title.insertAdjacentElement('afterend', share); }
    return share;
  }
  function build(){
    ensureArticleShare();
    var lists=document.querySelectorAll('.social-share ul.social');
    if(!lists.length) return;
    ensureStyle();
    var url=encodeURIComponent(location.href.split('#')[0]);
    var title=encodeURIComponent(document.title);
    var items=[
      {n:'x',label:'Share on X',href:'https://twitter.com/intent/tweet?text='+title+'&url='+url},
      {n:'instagram',label:'Instagram',href:IG},
      {n:'facebook',label:'Share on Facebook',href:'https://www.facebook.com/sharer.php?u='+url},
      {n:'linkedin',label:'Share on LinkedIn',href:'https://www.linkedin.com/sharing/share-offsite/?url='+url},
      {n:'pinterest',label:'Save on Pinterest',href:'https://pinterest.com/pin/create/button/?url='+url+'&description='+title},
      {n:'whatsapp',label:'Share on WhatsApp',href:'https://api.whatsapp.com/send?text='+title+'%20'+url}
    ];
    lists.forEach(function(ul){
      if(ul.dataset.dsShareReady) return; ul.dataset.dsShareReady='1';
      ul.innerHTML=items.map(function(it){
        return '<li><a class="social__link flex items-center justify-center ds-share-'+it.n+'" href="'+it.href+'" target="_blank" rel="noopener" title="'+it.label+'" aria-label="'+it.label+'">'+SVG[it.n]+'</a></li>';
      }).join('');
      ul.querySelectorAll('a').forEach(popupify);
    });
  }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded', build); } else { build(); }
  document.addEventListener('shopify:section:load', build);
})();
/* ---- Inject ISBN row into product Specifications list (ISBN = variant SKU) ---- */
(function(){
  function initISBN(){
    var ul=document.querySelector('ul.product-spec');
    if(!ul || ul.dataset.isbnReady) return;
    var m=location.pathname.match(/\/products\/([^\/?#]+)/);
    if(!m) return;
    ul.dataset.isbnReady='1';
    var already=[].some.call(ul.querySelectorAll('.product-spec__label'), function(l){ return /isbn/i.test(l.textContent); });
    if(already) return;
    fetch('/products/'+m[1]+'.js').then(function(r){ return r.ok?r.json():null; }).then(function(p){
      if(!p) return;
      var isbn='';
      if(p.variants && p.variants[0]) isbn=p.variants[0].sku||'';
      if(!isbn) return;
      var li=document.createElement('li');
      li.className='product-spec__item flex flex-col gap-x-theme md:flex-row pb-4 mb-4 last:pb-0 last:mb-0';
      li.innerHTML='<div class="product-spec__label mb-2 block font-bold">ISBN</div><div class="product-spec__value block">'+isbn+'</div>';
      ul.insertBefore(li, ul.firstElementChild);
    }).catch(function(){});
  }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded', initISBN); } else { initISBN(); }
  document.addEventListener('shopify:section:load', initISBN);
})();
//# sourceMappingURL=/cdn/shop/t/35/assets/wishlist.js.map
